import { render, staticRenderFns } from "./TemplateDetail.vue?vue&type=template&id=2adfde4c&scoped=true"
import script from "./TemplateDetail.vue?vue&type=script&lang=ts"
export * from "./TemplateDetail.vue?vue&type=script&lang=ts"
import style0 from "./TemplateDetail.vue?vue&type=style&index=0&id=2adfde4c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adfde4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2adfde4c')) {
      api.createRecord('2adfde4c', component.options)
    } else {
      api.reload('2adfde4c', component.options)
    }
    module.hot.accept("./TemplateDetail.vue?vue&type=template&id=2adfde4c&scoped=true", function () {
      api.rerender('2adfde4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/materials/TemplateDetail.vue"
export default component.exports